import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import MainFont from 'ui/typography/mainFont';

import { ContentWrapper, NotAvailable } from './style';

const PlaceholderTableData = ({ customText }) => {
  const { t } = useTranslation();
  return (
    <ContentWrapper>
      <NotAvailable>
        <MainFont type="4" configuration={{ fontSize: 16, lineHeight: '1.5' }}>
          {customText || t('no_data_search')}
        </MainFont>
      </NotAvailable>
    </ContentWrapper>
  );
};

PlaceholderTableData.propTypes = {
  customText: PropTypes.string
};

export default PlaceholderTableData;
